/**
 * localStorage for small per-browser conveniences (mute, last room). Access
 * can throw in private windows or with storage blocked, and nothing here is
 * essential, so every failure degrades to "not remembered".
 */
export const storage = {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Ignored: preference simply is not persisted.
    }
  },
  remove(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // Ignored.
    }
  },
};
